var map = {
	"./HotelImages/cromwell.webp": "32ed",
	"./HotelImages/cwell1.jpg": "3870",
	"./HotelImages/cwell10.jpg": "ded1",
	"./HotelImages/cwell2.jpg": "56cb",
	"./HotelImages/cwell3.jpg": "72e0",
	"./HotelImages/cwell4.jpg": "26ff",
	"./HotelImages/cwell5.jpg": "20af",
	"./HotelImages/cwell6.jpg": "62b3",
	"./HotelImages/cwell7.jpg": "8165",
	"./HotelImages/cwell8.jpg": "f991",
	"./HotelImages/cwell9.jpg": "bd99",
	"./HotelImages/delano.webp": "5c4f",
	"./HotelImages/delano1.jpg": "71e2",
	"./HotelImages/delano10.jpg": "706f",
	"./HotelImages/delano2.jpg": "3e2d",
	"./HotelImages/delano3.jpg": "0816",
	"./HotelImages/delano4.jpg": "0e89",
	"./HotelImages/delano5.jpg": "09e9",
	"./HotelImages/delano6.jpg": "e857",
	"./HotelImages/delano7.jpg": "c47b",
	"./HotelImages/delano8.jpg": "d444",
	"./HotelImages/delano9.jpg": "b5c9",
	"./HotelImages/erd.png": "1c99",
	"./HotelImages/logo.png": "a77e",
	"./HotelImages/logo.svg": "9933",
	"./HotelImages/map.png": "c882",
	"./HotelImages/nomad.webp": "62dc",
	"./HotelImages/nomad1.jpg": "2b57",
	"./HotelImages/nomad10.jpg": "c336",
	"./HotelImages/nomad2.jpg": "973d",
	"./HotelImages/nomad3.jpg": "7d28",
	"./HotelImages/nomad4.jpg": "ef80",
	"./HotelImages/nomad5.jpg": "0aef",
	"./HotelImages/nomad6.jpg": "ab9d",
	"./HotelImages/nomad7.jpg": "ea6a",
	"./HotelImages/nomad8.jpg": "0fa6",
	"./HotelImages/nomad9.jpg": "5dbc",
	"./HotelImages/pdf-icon-11.jpg": "6ed0",
	"./HotelImages/pdf.jpg": "2d68",
	"./HotelImages/pdf.png": "9b34",
	"./HotelImages/pdf1.jpg": "478a",
	"./HotelImages/vdara.webp": "8326",
	"./HotelImages/vdara1.jpg": "cb10",
	"./HotelImages/vdara10.jpg": "6f94",
	"./HotelImages/vdara2.jpg": "9927",
	"./HotelImages/vdara3.jpg": "6fd3",
	"./HotelImages/vdara4.jpg": "793d",
	"./HotelImages/vdara5.jpg": "0f34",
	"./HotelImages/vdara6.jpg": "4644",
	"./HotelImages/vdara7.jpg": "1286",
	"./HotelImages/vdara8.jpg": "3a32",
	"./HotelImages/vdara9.jpg": "e388",
	"./Ratings.png": "d959",
	"./aboutUs.png": "9b57",
	"./aboutus.svg": "ee68",
	"./back.svg": "ccfe",
	"./backgroundColor.png": "ee42",
	"./bg1.jpeg": "51f0",
	"./bg2.jpg": "975a",
	"./bg3.jpg": "890f",
	"./bg4.jpg": "0815",
	"./bus.png": "0ea3",
	"./calendar.png": "2cc6",
	"./car.jpg": "f5c2",
	"./cart.png": "41b9",
	"./cart.svg": "6f5d",
	"./cromwell.webp": "c3de",
	"./cwell1.jpg": "be80",
	"./cwell10.jpg": "ff67",
	"./cwell2.jpg": "3ff1",
	"./cwell3.jpg": "825b",
	"./cwell4.jpg": "69e4",
	"./cwell5.jpg": "db6e",
	"./cwell6.jpg": "b5c7",
	"./cwell7.jpg": "53b8",
	"./cwell8.jpg": "3fbc",
	"./cwell9.jpg": "e03b",
	"./delano.webp": "125c",
	"./delano1.jpg": "b84e",
	"./delano10.jpg": "47f3",
	"./delano2.jpg": "2ed4",
	"./delano3.jpg": "0150",
	"./delano4.jpg": "8bd8",
	"./delano5.jpg": "d28d",
	"./delano6.jpg": "bf08",
	"./delano7.jpg": "1443",
	"./delano8.jpg": "a044",
	"./delano9.jpg": "c0c3",
	"./floppy-icon.png": "f511",
	"./headset.png": "b6a9",
	"./id.svg": "bc01",
	"./list.png": "6e2c",
	"./logo.png": "cf05",
	"./logo.svg": "9b19",
	"./map.png": "8b55",
	"./maps.png": "bf8e",
	"./menu.svg": "36be",
	"./message.svg": "e36a",
	"./nomad.webp": "c767",
	"./nomad1.jpg": "35a6",
	"./nomad10.jpg": "7191",
	"./nomad2.jpg": "80ab",
	"./nomad3.jpg": "9760",
	"./nomad4.jpg": "84af",
	"./nomad5.jpg": "1984",
	"./nomad6.jpg": "5889",
	"./nomad7.jpg": "55b7",
	"./nomad8.jpg": "85c7",
	"./nomad9.jpg": "55d4",
	"./pdf-icon-11.jpg": "908b",
	"./pdf.jpg": "03d7",
	"./pdf.png": "9f06",
	"./pdf1.jpg": "4fe0",
	"./phone.svg": "001e",
	"./scooba.jpg": "ffd2",
	"./shopping-cart.svg": "568d",
	"./sidebar.svg": "8070",
	"./signout.svg": "c141",
	"./smartphone.svg": "0cc8",
	"./stretchlimo.jpg": "a5fd",
	"./time.png": "5567",
	"./translate.png": "f714",
	"./trash.svg": "c6378",
	"./user.svg": "0f62",
	"./vdara.webp": "5d6f",
	"./vdara1.jpg": "cbe3",
	"./vdara10.jpg": "4643",
	"./vdara2.jpg": "cc87",
	"./vdara3.jpg": "b44c",
	"./vdara4.jpg": "f20d",
	"./vdara5.jpg": "a4bf",
	"./vdara6.jpg": "4ef5",
	"./vdara7.jpg": "af0b",
	"./vdara8.jpg": "9e5c",
	"./vdara9.jpg": "1ad9",
	"./yacht.jpg": "6f65"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";